import React from 'react';
import { Col, Row } from 'antd';
import AntTable from '../../components/AntTableFixedHeader/AntTable';
import AntButton from '../../components/AntButton/AntButton';
import AntSearch from '../../components/AntSearch/AntSearch';
import AntFilter from '../../components/AntFilter/AntFilter';
import useQuizManagement from './logic/useQuizManagement';

const QuizManagement = () => {
    
    const {
        deleteFn,
        updateFn,
        navigateToQuizCreation,
        onChange,
        data,
        isFetching,
        getSearchData,
        getFilterData,
        switcherFn,
        previewFn
    } = useQuizManagement(); 

    return (
        <div>
            <div style={{ marginBottom: '2%' }}>
                <Row justify="end" align="bottom" gutter={16}>
                    <Col span={6}><AntSearch placeholder='Course Name' getData={getSearchData} /></Col>
                    <Col span={3}>
                        <AntFilter fields={["courseName", "quizName", "status", "createdAt", "numberOfquestions"]} getData={getFilterData} />
                    </Col>
                    <Col span={2}>
                        <AntButton type={"primary"} text={'Create'} size={'large'} color={"#185993"} onClick={() => { navigateToQuizCreation() }} />
                    </Col>
                </Row>
            </div>
            <Row>
                <Col span={24}>
                    <AntTable data={data} updateFn={updateFn} deleteFn={deleteFn} onChange={onChange} isFetching={isFetching} switcherFn={switcherFn} previewFn={previewFn} />
                </Col>
            </Row>
        </div>
    );
}

export default QuizManagement;
